// extracted by mini-css-extract-plugin
export default {"ImageGrid":"ImageGrid_ImageGrid__GL1mn","gridImage":"ImageGrid_gridImage__JiSLD","singleImage":"ImageGrid_singleImage__DGLf3"};